export default __webpack_public_path__ + "static/media/benefit_3@2x.b3c8d0b5.png";